const template=`
<widget-status></widget-status>
<google-analytics-highchart chart-data="chartData" drill="drillDown()" ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured"></google-analytics-highchart>
<div class="googleErrorContainerMinView" ng-show="googleError.message"><a class="googleErrorWarning" ng-show="googleError.anchor" href="{{googleError.anchor}}">{{googleError.message}}</a><span class="googleErrorWarning" ng-show="!googleError.anchor">{{googleError.message}}</span></div>`;
export default template;
